module.exports = __webpack_public_path__ + "img/wyqy.edd208f1.png";